import { useCallback, useState } from "react";
import { CatalogBuilder } from "../../../../commonGroupModuleStructure/catalogBuilder";
import { MuiPopup } from "../../../../components";
import { FormBuilderContainer } from "../../../../components/formBuilder/formBuilder.container";
import { FormItemTypes, IFormBuilder } from "../../../../components/formBuilder/formBuilder.entity";
import { createRoleFeatureMapping, deleteRoleFeatureMapping, getRoleFeatureMapping, getRoleNotInFeatures } from "../apiCall";
import { RoleKeys } from "../entity";

export const RoleFeatureMapping = (props: any) => {
  const { request } = props;
  const [open, setOpen] = useState<boolean>(false);

  const onClose = useCallback(() => { setOpen(false) }, []);
  const onClickPlus = useCallback(() => { setOpen(true) }, []);

  const formData: IFormBuilder['formData'] = [
    {
      type: FormItemTypes.TreeList,
      name: 'Modules',
      label: 'Add Role Feature Mapping',
      value: null,
      getItems: getRoleNotInFeatures,
      apiKey: RoleKeys.notInFeatures,
      apiRequest: request,
      valueSetter: (values: any) => values?.map((item: any) => ({
        FeatureId: item.FeatureId,
        ModuleId: item.ModuleId,
        MenuId: item.MenuId,
      })),
      itemSize: 12
    }
  ]

  return (
    <>
      <CatalogBuilder
        isAssociationButton={true}
        disableEditAction
        disableViewAction

        getPagingData={getRoleFeatureMapping}
        pagingAPIrequest={{ ...request, take: 50 }}
        pagingAPIKey={RoleKeys.getFeatureMapping}

        onDelete={deleteRoleFeatureMapping}
        deletePagingAPIKey={RoleKeys.deleteFeatureMapping}
        onClickPlus={onClickPlus}
        visibleColumns={{
          RoleName: false
        }}

        dataGridProps={{
          initialState: {
            rowGrouping: {
              model: ['MenuName']
            },
          },
          groupingColDef: {
            minWidth: 300,
          },
        }}
      />
      <MuiPopup openPopup={open} onClose={onClose} disableCloseIcon={true} >
        <FormBuilderContainer
          formData={formData}
          isRightMenu
          headerLabel="Add Role-Features Mapping"
          mode="add"

          createFormAPI={createRoleFeatureMapping}
          createKey={RoleKeys.create}
          createRequest={request}

          onClose={onClose}
        />
      </MuiPopup>
    </>

  );
}